import { portal as portalService } from "../../services/index.js";

const state = {
  view: {},
  styles: {},
  isMobile: false,
  spot: {}
};

const getters = {
  view: state => state.view,
  styles: state => state.styles
};

const mutations = {
  setView(state, view) {
    state.view = view;
  },
  setStyle(state, style) {
    state.styles[style.id] = style.style;
  },
  setMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
  setSpot(state, spot) {
    state.spot = spot;
  }
};

const actions = {
  get(context) {
    return portalService.get().then(data => {
      context.commit("setView", data);
    });
  },
  setStyle(context, style) {
    context.commit("setStyle", style);
  },
  getSpot(context, id) {
    return portalService.getSpot(id).then(data => {
      context.commit("setSpot", data);
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
